module.exports = __webpack_public_path__ + "img/ID.bee0c3cf.svg";